import { getAll as getPastResults } from "lib/models/QuizTaken";

export default async (user, country) => {
  const keys = ["products.best", "quiz", "tag"];

  const results = await getPastResults(user, keys, country);

  return results;
};
